import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PrivacyDialogComponent } from '../privacy-dialog/privacy-dialog.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(private _dialog: MatDialog) { }

  openDialog(link: string) {
    const iFramelink = link;
    let width;
    if (window.innerWidth > 1024) {
      width = "60%";
    } else if (window.innerWidth > 600) {
      width = "80%";
    } else if (window.innerWidth < 600) {
      width = "100%";
    }
    const dialogRef = this._dialog.open(PrivacyDialogComponent, {
      height: "70%",
      width: width,
      data: iFramelink
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
